export const optionsFromLabels = <T extends string>(
  labels: Record<T, string>,
): { value: T; label: string }[] =>
  (Object.entries(labels) as [T, string][]).map(([value, label]) => ({ value, label }));
